module.exports = __webpack_public_path__ + "img/img_product_07_02@2x.fc0cece0.png";